import { BaseIdentity } from './base-identity';
import { BaseRowNumberModel } from './base-row-number-model';
import { DomainModelCollection } from './domain-model-collection';


export abstract class DomainModelRowNumberCollection<TItem extends BaseRowNumberModel<TIdentity>, TIdentity extends BaseIdentity>
    extends DomainModelCollection<TItem, TIdentity> {

}
